import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('ah_admin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Public
export const getMembers = (params = {}) => client.get('/members', { params }).then((r) => r.data);
export const getCategories = () => client.get('/members/categories').then((r) => r.data);
export const getMember = (id) => client.get(`/members/${id}`).then((r) => r.data);
export const getNews = (all = false) => client.get('/news', { params: { all } }).then((r) => r.data);
export const getNewsItem = (id) => client.get(`/news/${id}`).then((r) => r.data);
export const submitApplication = (data) => client.post('/applications', data).then((r) => r.data);
export const submitContact = (data) => client.post('/contact', data).then((r) => r.data);
export const subscribeNewsletter = (email) => client.post('/subscribe', { email }).then((r) => r.data);

// Admin
export const adminLogin = (password) => client.post('/admin/login', { password }).then((r) => r.data);
export const getStats = () => client.get('/admin/stats').then((r) => r.data);
export const getApplications = () => client.get('/applications').then((r) => r.data);
export const updateApplication = (id, status) => client.put(`/applications/${id}`, { status }).then((r) => r.data);
export const deleteApplication = (id) => client.delete(`/applications/${id}`).then((r) => r.data);
export const getMessages = () => client.get('/contact').then((r) => r.data);
export const deleteMessage = (id) => client.delete(`/contact/${id}`).then((r) => r.data);
export const createNews = (data) => client.post('/news', data).then((r) => r.data);
export const updateNews = (id, data) => client.put(`/news/${id}`, data).then((r) => r.data);
export const deleteNews = (id) => client.delete(`/news/${id}`).then((r) => r.data);
export const createMember = (data) => client.post('/members', data).then((r) => r.data);
export const updateMember = (id, data) => client.put(`/members/${id}`, data).then((r) => r.data);
export const deleteMember = (id) => client.delete(`/members/${id}`).then((r) => r.data);
export const getSubscribers = () => client.get('/subscribers').then((r) => r.data);
export const getEvents = (all = false) => client.get('/events', { params: { all } }).then((r) => r.data);
export const getEvent = (id) => client.get(`/events/${id}`).then((r) => r.data);
export const createEvent = (data) => client.post('/events', data).then((r) => r.data);
export const updateEvent = (id, data) => client.put(`/events/${id}`, data).then((r) => r.data);
export const deleteEvent = (id) => client.delete(`/events/${id}`).then((r) => r.data);
export const checkPromo = (eventId, code) => client.post(`/events/${eventId}/promo`, { code }).then((r) => r.data);
export const setGuestCheckin = (id, gid, checked_in) => client.patch(`/rsvps/${id}/guests/${gid}/checkin`, { checked_in }).then((r) => r.data);
export const setRsvpCheckin = (id, checked_in) => client.patch(`/rsvps/${id}/checkin`, { checked_in }).then((r) => r.data);
export const getMemberBusinesses = () => client.get('/member-businesses').then((r) => r.data);
export const setRsvpPaid = (id, paid) => client.patch(`/rsvps/${id}/paid`, { paid }).then((r) => r.data);
export const submitRsvp = (data) => client.post('/rsvps', data).then((r) => r.data);
export const getRsvpSummary = () => client.get('/rsvps/summary').then((r) => r.data);
export const getRsvps = (eventId) => client.get('/rsvps', { params: { event_id: eventId } }).then((r) => r.data);
export const deleteRsvp = (id) => client.delete(`/rsvps/${id}`).then((r) => r.data);
export const getNewsletterOpens = (id) => client.get(`/newsletters/${id}/opens`).then((r) => r.data);
export const cancelNewsletter = (id) => client.delete(`/newsletters/${id}`).then((r) => r.data);
export const getTemplates = () => client.get('/newsletter-templates').then((r) => r.data);
export const saveTemplate = (data) => client.post('/newsletter-templates', data).then((r) => r.data);
export const deleteTemplate = (id) => client.delete(`/newsletter-templates/${id}`).then((r) => r.data);
export const getNewsletters = () => client.get('/newsletters').then((r) => r.data);
export const sendTestNewsletter = (data) => client.post('/newsletters/test', data).then((r) => r.data);
export const sendNewsletter = (data) => client.post('/newsletters/send', data).then((r) => r.data);
export const addSubscriber = (data) => client.post('/subscribers/manual', data).then((r) => r.data);
export const addSubscribersBulk = (text, groups = []) => client.post('/subscribers/bulk', { text, groups }).then((r) => r.data);
export const setSubscriberGroups = (id, groups) => client.put(`/subscribers/${id}/groups`, { groups }).then((r) => r.data);
export const bulkSubscriberGroup = (ids, group, action) => client.post('/subscribers/groups/bulk', { ids, group, action }).then((r) => r.data);
export const unsubscribe = (token) => client.post('/unsubscribe', { token }).then((r) => r.data);
export const resubscribe = (token) => client.post('/resubscribe', { token }).then((r) => r.data);
export const addSubscribersFromMembers = () => client.post('/subscribers/from-members').then((r) => r.data);
export const importSubscribers = (file, groups = []) => {
  const fd = new FormData();
  fd.append('file', file);
  fd.append('groups', groups.join(','));
  return client.post('/subscribers/import', fd).then((r) => r.data);
};
export const deleteSubscriber = (id) => client.delete(`/subscribers/${id}`).then((r) => r.data);

export const uploadMemberPhoto = (file) => {
  const fd = new FormData();
  fd.append('file', file);
  return client.post('/upload/member-photo', fd, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then((r) => ({ ...r.data, absoluteUrl: `${BACKEND_URL}${r.data.url}` }));
};
export const importMembers = (file) => {
  const fd = new FormData();
  fd.append('file', file);
  return client.post('/import/members', fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data);
};
export const downloadCsv = async (kind, params = {}) => {
  const res = await client.get(`/export/${kind}.csv`, { params, responseType: 'blob' });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement('a');
  a.href = url; a.download = `${kind}.csv`;
  document.body.appendChild(a); a.click(); a.remove();
  URL.revokeObjectURL(url);
};

export const isLoggedIn = () => !!sessionStorage.getItem('ah_admin_token');
export const logout = () => sessionStorage.removeItem('ah_admin_token');

export default client;
